var map = {
	"./images/article2/connection.jpg": 11,
	"./images/article2/connection@2x.jpg": 12,
	"./images/article2/graphic1-lg.png": 13,
	"./images/article2/graphic1-sm.png": 14,
	"./images/article2/graphic2-lg.png": 15,
	"./images/article2/graphic2-sm.png": 16,
	"./images/article2/guiding-principles.jpg": 17,
	"./images/article2/guiding-principles@2x.jpg": 18,
	"./images/article2/innovation.jpg": 19,
	"./images/article2/innovation@2x.jpg": 20,
	"./images/article2/share.jpg": 21,
	"./images/article2/trade.jpg": 22,
	"./images/article2/trade@2x.jpg": 23,
	"./images/article2/transaction.jpg": 24,
	"./images/article2/transaction@2x.jpg": 25,
	"./images/article2/video-poster.jpg": 26,
	"./images/article2/video-poster@2x.jpg": 27,
	"./images/article2/vision.jpg": 28,
	"./images/article2/vision@2x.jpg": 29,
	"./images/article3/afreximbank.jpg": 30,
	"./images/article3/afreximbank@2x.jpg": 31,
	"./images/article3/baza-1.jpg": 32,
	"./images/article3/baza-1@2x.jpg": 33,
	"./images/article3/baza-2.jpg": 34,
	"./images/article3/baza-2@2x.jpg": 35,
	"./images/article3/baza-3.jpg": 36,
	"./images/article3/baza-3@2x.jpg": 37,
	"./images/article3/can-you-see-us.jpg": 38,
	"./images/article3/can-you-see-us@2x.jpg": 39,
	"./images/article3/graphic-1-base.png": 40,
	"./images/article3/graphic-1-base@2x.png": 41,
	"./images/article3/graphic-1-dots.png": 42,
	"./images/article3/graphic-1-dots@2x.png": 43,
	"./images/article3/graphic-1-lines.png": 44,
	"./images/article3/graphic-1-lines@2x.png": 45,
	"./images/article3/graphic-2-1.png": 46,
	"./images/article3/graphic-2-1@2x.png": 47,
	"./images/article3/graphic-2-2.png": 48,
	"./images/article3/graphic-2-2@2x.png": 49,
	"./images/article3/share.jpg": 50,
	"./images/article3/video-poster.jpg": 51,
	"./images/article3/video-poster@2x.jpg": 52,
	"./images/article3/widget-1.svg": 53,
	"./images/article3/widget-2.svg": 54,
	"./images/article3/widget-3.svg": 55,
	"./images/article3/widget-4.svg": 56,
	"./images/article4/city.jpg": 57,
	"./images/article4/city@2x.jpg": 58,
	"./images/article4/forum.jpg": 59,
	"./images/article4/forum@2x.jpg": 60,
	"./images/article4/infinite.png": 61,
	"./images/article4/infinite@2x.png": 62,
	"./images/article4/panel1.jpg": 63,
	"./images/article4/panel1@2x.jpg": 64,
	"./images/article4/panel2.jpg": 65,
	"./images/article4/panel2@2x.jpg": 66,
	"./images/article4/public.jpg": 67,
	"./images/article4/public@2x.jpg": 68,
	"./images/article4/share.jpg": 69,
	"./images/article4/speaker.jpg": 70,
	"./images/article4/speaker@2x.jpg": 71,
	"./images/article4/video-poster.jpg": 72,
	"./images/article4/video-poster@2x.jpg": 73,
	"./images/article5/caribbean.jpg": 74,
	"./images/article5/caribbean@2x.jpg": 75,
	"./images/article5/destiny.jpg": 76,
	"./images/article5/destiny@2x.jpg": 77,
	"./images/article5/global-africa.jpg": 78,
	"./images/article5/global-africa@2x.jpg": 79,
	"./images/article5/logo-afreximbank.svg": 80,
	"./images/article5/milestone.jpg": 81,
	"./images/article5/milestone@2x.jpg": 82,
	"./images/article5/share.jpg": 83,
	"./images/article5/tags.svg": 84,
	"./images/article5/video-poster.jpg": 85,
	"./images/article5/video-poster@2x.jpg": 86,
	"./images/article6/economic-prosperity.jpg": 87,
	"./images/article6/economic-prosperity@2x.jpg": 88,
	"./images/article6/global-africa.jpg": 89,
	"./images/article6/global-africa@2x.jpg": 90,
	"./images/article6/logo-afreximbank-black-text.svg": 91,
	"./images/article6/logo-afreximbank-white-text.svg": 92,
	"./images/article6/logo-afreximbank.svg": 93,
	"./images/article6/owning-a-shared-destiny.jpg": 94,
	"./images/article6/owning-a-shared-destiny@2x.jpg": 95,
	"./images/article6/share.jpg": 96,
	"./images/article6/video-poster-mobile.jpg": 97,
	"./images/article6/video-poster-mobile@2x.jpg": 98,
	"./images/article6/video-poster.jpg": 99,
	"./images/article6/video-poster@2x.jpg": 100,
	"./images/article6/viola-davis.jpg": 101,
	"./images/article6/viola-davis@2x.jpg": 102,
	"./images/article7/catwalk.jpg": 103,
	"./images/article7/catwalk@2x.jpg": 104,
	"./images/article7/dance.jpg": 105,
	"./images/article7/dance@2x.jpg": 106,
	"./images/article7/finance.jpg": 107,
	"./images/article7/finance@2x.jpg": 108,
	"./images/article7/group-photo.jpg": 109,
	"./images/article7/group-photo@2x.jpg": 110,
	"./images/article7/impact.jpg": 111,
	"./images/article7/impact@2x.jpg": 112,
	"./images/article7/logo-afreximbank-black-text.svg": 113,
	"./images/article7/logo-afreximbank-white-text.svg": 114,
	"./images/article7/logo-afreximbank.svg": 115,
	"./images/article7/music.jpg": 116,
	"./images/article7/music@2x.jpg": 117,
	"./images/article7/share.jpg": 118,
	"./images/article7/talks.jpg": 119,
	"./images/article7/talks@2x.jpg": 120,
	"./images/article7/video-poster-mobile.jpg": 121,
	"./images/article7/video-poster-mobile@2x.jpg": 122,
	"./images/article7/video-poster.jpg": 123,
	"./images/article7/video-poster@2x.jpg": 124,
	"./images/article8/greetings.jpg": 125,
	"./images/article8/greetings@2x.jpg": 126,
	"./images/article8/leaders.jpg": 127,
	"./images/article8/leaders@2x.jpg": 128,
	"./images/article8/logo-afreximbank-black-text.svg": 129,
	"./images/article8/logo-afreximbank-white-text.svg": 130,
	"./images/article8/logo-afreximbank.svg": 131,
	"./images/article8/networking.jpg": 132,
	"./images/article8/networking@2x.jpg": 133,
	"./images/article8/share.jpg": 134,
	"./images/article8/solarpanels.jpg": 135,
	"./images/article8/solarpanels@2x.jpg": 136,
	"./images/article8/sustainability.jpg": 137,
	"./images/article8/sustainability@2x.jpg": 138,
	"./images/article8/talks.jpg": 139,
	"./images/article8/talks@2x.jpg": 140,
	"./images/article8/video-poster-mobile.jpg": 141,
	"./images/article8/video-poster-mobile@2x.jpg": 142,
	"./images/article8/video-poster.jpg": 143,
	"./images/article8/video-poster@2x.jpg": 144,
	"./images/article8/women.jpg": 145,
	"./images/article8/women@2x.jpg": 146,
	"./images/building.jpg": 147,
	"./images/building@2x.jpg": 148,
	"./images/conversations.jpg": 149,
	"./images/conversations@2x.jpg": 150,
	"./images/end-cta.png": 151,
	"./images/end-cta.svg": 152,
	"./images/end-cta@2x.png": 153,
	"./images/graphics/g1-c1.png": 154,
	"./images/graphics/g1-c2.png": 155,
	"./images/graphics/g1-c3.png": 156,
	"./images/graphics/g1-globe.png": 157,
	"./images/graphics/g2-africa.png": 158,
	"./images/graphics/g2-cog.png": 159,
	"./images/greetings.jpg": 160,
	"./images/greetings@2x.jpg": 161,
	"./images/logo-afreximbank-black-text.svg": 162,
	"./images/logo-afreximbank-white-text.svg": 163,
	"./images/logo-afreximbank-white.svg": 164,
	"./images/logo-afreximbank.svg": 165,
	"./images/logo_cnn.svg": 166,
	"./images/notes.jpg": 167,
	"./images/notes@2x.jpg": 168,
	"./images/share.jpg": 169,
	"./images/talk.jpg": 170,
	"./images/talk@2x.jpg": 171,
	"./images/thumb-article1.jpg": 172,
	"./images/thumb-article1@2x.jpg": 173,
	"./images/thumb-article2.jpg": 174,
	"./images/thumb-article2@2x.jpg": 175,
	"./images/thumb-article3.jpg": 176,
	"./images/thumb-article3@2x.jpg": 177,
	"./images/thumb-article4.jpg": 178,
	"./images/thumb-article4@2x.jpg": 179,
	"./images/thumb-article5.jpg": 180,
	"./images/thumb-article5@2x.jpg": 181,
	"./images/thumb-article6.jpg": 182,
	"./images/thumb-article6@2x.jpg": 183,
	"./images/thumb-article7.jpg": 184,
	"./images/thumb-article7@2x.jpg": 185,
	"./images/thumb-article8.jpg": 186,
	"./images/thumb-article8@2x.jpg": 187,
	"./images/video-poster.jpg": 188,
	"./images/video-poster@2x.jpg": 189,
	"./video/a2_loop.mp4": 190,
	"./video/a3_loop.mp4": 191,
	"./video/a4_loop.mp4": 192,
	"./video/a5_loop.mp4": 193,
	"./video/a6_loop-mob.mp4": 194,
	"./video/a6_loop.mp4": 195,
	"./video/a7_loop-mob.mp4": 196,
	"./video/a7_loop.mp4": 197,
	"./video/a8_loop-mob.mp4": 198,
	"./video/a8_loop.mp4": 199,
	"./video/loop.mp4": 200
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 209;


//////////////////
// WEBPACK FOOTER
// ./src/media ^\.\/.*\.*
// module id = 209
// module chunks = 0